import React, { useEffect, useRef, useState, useCallback } from "react";
import { bootstrapCameraKit } from "@snap/camera-kit";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { getLensIdFromBarcode } from "./barcode";


const DEFAULT_LENS_ID = "4413b338-743c-4634-bdbd-7d0e9d9e44c0";
const DEFAULT_GROUP_ID = "a0c7f4f8-6ace-4d41-9a3a-f7e4dc2d65bd"
const apiURL = process.env.REACT_APP_API_KEY;

const constraints = {
    video: {
        facingMode: "user",
        aspectRatio: 9 / 16,
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30 },
        objectFit: "cover",
    },
};

const Activatelens = () => {
    const [lensLoaded, setLensLoaded] = useState(false);
    const [activeLensId, setActiveLensId] = useState(null);
    const [lensName, setLensName] = useState(null);
    // const [groupId, setGroupId] = useState(null);

    const [searchParams] = useSearchParams();
    // const lensId = searchParams.get("lensId");
    // const groupId = searchParams.get("groupId");
    // const barcode = searchParams.get("barcode") || DEFAULT_LENS_ID;

    const { lensId, groupId, barcode } = useParams();
    const finalBarcode = barcode || DEFAULT_LENS_ID;


    //     const [searchParams] = useSearchParams();
    // const encoded = searchParams.get("data");

    // let lensId, groupId, barcode;
    // try {
    //   const decoded = JSON.parse(atob(encoded));
    //   lensId = decoded.lensId;
    //   groupId = decoded.groupId;
    //   barcode = decoded.barcode || DEFAULT_LENS_ID;
    // } catch (e) {
    //   // fallback or redirect if tampered
    //   console.error("Invalid lens data");
    // }

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const snapMediaStreamRef = useRef(null);
    const sessionRef = useRef(null);
    const cameraKitRef = useRef(null);

    const navigate = useNavigate();



    const ensureCanvas = () => {
        if (!canvasRef.current) {
            const canvas = document.createElement("canvas");
            canvas.id = "my-canvas";

            // Set styles
            Object.assign(canvas.style, {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: "scaleX(-1)",
                zIndex: "1", // Optional: ensure it's rendered above background
            });

            // Try WebGL2
            let gl = canvas.getContext("webgl2", {
                antialias: false,
                preserveDrawingBuffer: false,
                powerPreference: "high-performance",
            });

            if (!gl) {
                console.warn("WebGL2 not supported, falling back to WebGL.");
                gl = canvas.getContext("webgl", {
                    antialias: false,
                    preserveDrawingBuffer: false,
                    powerPreference: "high-performance",
                });

                if (!gl) {
                    console.error("Neither WebGL2 nor WebGL is supported.");
                    return;
                }
            }

            document.body.appendChild(canvas);
            canvasRef.current = canvas;
        } else if (!document.body.contains(canvasRef.current)) {
            document.body.appendChild(canvasRef.current);
        }
    };



    // e37fac64-5cd0-46df-b60a-0ac912ff3d05
    // 6578fc00-bb43-4a06-9f3e-1fe122687422


    const activateLens = useCallback(async (lensId) => {
        try {
            if (lensLoaded || activeLensId === lensId) {
                console.log(`Lens ${lensId} is already active.`);
                return;
            }

            console.log("Initializing Camera Kit...");

            if (!cameraKitRef.current) {
                cameraKitRef.current = await bootstrapCameraKit({
                    apiToken: apiURL,
                    clientId: "3157d7b6-85ec-440f-bf74-d5ead84bc956", // OAuth 2.0 Public Client ID
                });
            }

            ensureCanvas();

            if (sessionRef.current) {
                console.log("Destroying previous session...");
                try {
                    await sessionRef.current.destroy();
                } catch (e) {
                    console.warn("Failed to destroy previous session cleanly:", e);
                }
                sessionRef.current = null;
            }


            if (cameraKitRef.current?.getCapabilities) {
                const capabilities = await cameraKitRef.current.getCapabilities();
                console.log("Camera Kit Capabilities:", capabilities);
            } else {
                // console.warn("getCapabilities is not available on this version.");
            }


            sessionRef.current = await cameraKitRef.current.createSession({
                liveRenderTarget: canvasRef.current,
                graphicsQuality: "low",
                video: {
                    facingMode: "user",
                    // enableFrameRate: true,
                    enabledFaceTracking: true,
                    enabledBodyTracking: true,
                    enabledBodySegmentation: true,
                    enabledBodyMesh: true,
                    enabledBodyOcclusion: true,
                    webglVersion: "webgl2",
                    frameRate: { ideal: 60 },
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                },
            });

            if (!snapMediaStreamRef.current) {
                const constraints = {
                    video: {
                        facingMode: "user",
                        // enableFrameRate: true,
                        enabledFaceTracking: true,
                        enabledBodyTracking: true,
                        enabledBodySegmentation: true,
                        enabledBodyMesh: true,
                        enabledBodyOcclusion: true,
                        webglVersion: "webgl2",
                        frameRate: { ideal: 60 },
                        width: { ideal: 1280 },
                        height: { ideal: 720 },
                    },
                };
                snapMediaStreamRef.current = await navigator.mediaDevices.getUserMedia(constraints);
            }

            console.log(navigator.mediaDevices.getUserMedia);
            console.log("This is navigator agent:", navigator.userAgent)

            await sessionRef.current.setSource(snapMediaStreamRef.current);
            await sessionRef.current.play();
            console.log("Snap Camera session started.");


            let currentLens;
            try {
                currentLens = await cameraKitRef.current.lensRepository.loadLens(lensId, groupId);
            } catch (e) {
                console.error("loadLens failed:", e.message || e);
                if (e.details) console.error("Details:", e.details);
                alert("Error, Please check lensId and groupId again.");
                return;
            }
            if (!currentLens) throw new Error("Lens could not be loaded!");

            console.log(`Applying Lens: ${lensId}`);
            await sessionRef.current.applyLens(currentLens);

            setLensLoaded(true);
            setActiveLensId(lensId);
            console.log(`Lens ${lensId} activated.`);
        } catch (error) {
            console.error("Error activating lens:", error.message || error);
            if (error.details) console.error("Details:", error.details);
        }
    }, [lensLoaded, activeLensId, apiURL, groupId]);




    useEffect(() => {
        const fetchGroupId = async () => {
            if (!finalBarcode) return;
            const data = await getLensIdFromBarcode(finalBarcode);
            setLensName(data.lensName ?? "Default Lens");
        };
        fetchGroupId();
    }, [finalBarcode]);

    useEffect(() => {
        if (lensId && groupId) {
            activateLens(lensId);
        }
    }, [lensId, groupId, activateLens]);


    const stopLens = async () => {
        try {
            navigate(-1);
            // window.close();
        } catch (error) {
            console.error(" Error closing lens:", error);
        }
    };

    return (
        <div
            style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            <div style={{
                position: "absolute",
                top: "50px",
                left: "20%",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "4px 8px",
                zIndex: 10,
                background: "rgba(0, 0, 0, 0.4)",
                borderRadius: "6px",
                fontSize: "13px",
                color: "white",
                fontWeight: "400",
                backdropFilter: "blur(4px)",
                whiteSpace: "nowrap"
            }}>
                {lensName}
            </div>
            <button
                onClick={stopLens}
                style={{
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    padding: "10px 20px",
                    fontSize: "15px",
                    background: "rgba(0, 0, 0, 0.7)",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    fontWeight: "700",
                    cursor: "pointer",
                    zIndex: 10,
                }}
            >
                Back to Scanning
            </button>

            <canvas
                ref={canvasRef}
                id="my-canvas"
                style={{
                    height: "100%",
                    width: "100%",
                    // aspectRatio: 16 / 9,
                    // aspectRatio: 4 / 3,
                    transform: "scaleX(-1)",
                    borderRadius: "15px",
                }}
            />
        </div>
    );
};

export default Activatelens;



/*
import React, { useEffect, useRef, useState, useCallback } from "react";
import { bootstrapCameraKit } from "@snap/camera-kit";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getLensIdFromBarcode } from "./barcode";

const DEFAULT_LENS_ID = "4413b338-743c-4634-bdbd-7d0e9d9e44c0";
const DEFAULT_GROUP_ID = "a0c7f4f8-6ace-4d41-9a3a-f7e4dc2d65bd";
const apiURL = process.env.REACT_APP_API_KEY;

const Activatelens = () => {
    const [lensLoaded, setLensLoaded] = useState(false);
    const [activeLensId, setActiveLensId] = useState(null);
    const [lensName, setLensName] = useState(null);
    const [readyToActivate, setReadyToActivate] = useState(false);

    const [searchParams] = useSearchParams();
    const lensId = searchParams.get("lensId");
    const groupId = searchParams.get("groupId") || DEFAULT_GROUP_ID;
    const barcode = searchParams.get("barcode") || DEFAULT_LENS_ID;

    const canvasRef = useRef(null);
    const snapMediaStreamRef = useRef(null);
    const sessionRef = useRef(null);
    const cameraKitRef = useRef(null);

    const navigate = useNavigate();

    const ensureCanvas = () => {
        if (!canvasRef.current) {
            const canvas = document.createElement("canvas");
            canvas.id = "my-canvas";
            Object.assign(canvas.style, {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                // transform: "scaleX(-1)",
                transform: "translateZ(0)",
                willchange: "transform",
                zIndex: "1",
            });

            let gl = canvas.getContext("webgl2", {
                antialias: false,
                preserveDrawingBuffer: false,
                powerPreference: "high-performance",
            });

            if (!gl) {
                console.warn("WebGL2 not supported, falling back to WebGL.");
                gl = canvas.getContext("webgl", {
                    antialias: false,
                    preserveDrawingBuffer: false,
                    powerPreference: "high-performance",
                });

                if (!gl) {
                    console.error("Neither WebGL2 nor WebGL is supported.");
                    return;
                }
            }

            document.body.appendChild(canvas);
            canvasRef.current = canvas;
        } else if (!document.body.contains(canvasRef.current)) {
            document.body.appendChild(canvasRef.current);
        }
    };

    const activateLens = useCallback(async (lensId) => {
        try {
            if (lensLoaded || activeLensId === lensId) {
                console.log(`Lens ${lensId} is already active.`);
                return;
            }

            if (!cameraKitRef.current) {
                cameraKitRef.current = await bootstrapCameraKit({
                    apiToken: apiURL,
                    clientId: "3157d7b6-85ec-440f-bf74-d5ead84bc956",
                });
            }

            if (sessionRef.current) {
                try {
                    await sessionRef.current.destroy();
                } catch (e) {
                    console.warn("Failed to destroy previous session cleanly:", e);
                }
                sessionRef.current = null;
            }

            const isIOS =
                /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                (navigator.userAgent === "MacIntel" && navigator.maxTouchPoints > 1);
            const webglVersion = isIOS ? "webgl2" : "webgl";

            sessionRef.current = await cameraKitRef.current.createSession({
                liveRenderTarget: canvasRef.current,
                graphicsQuality: "high",
                video: {
                    facingMode: "user",
                    webglVersion,
                    frameRate: { ideal: 60 },
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    objectFit: "cover",
                    autoFocus: true,
                    zoom: false,
                    transform: "scaleX(-1)"
                },
            });

            if (!snapMediaStreamRef.current) {
                const mediaConstraints = {
                    video: {
                        facingMode: "user",
                        frameRate: { ideal: 60 },
                        width: { ideal: 1280 },
                        height: { ideal: 720 },
                        objectFit: "cover",
                        autoFocus: true,
                        zoom: false,
                        transform: "scaleX(-1)"
                    },
                    audio: false,
                };
                snapMediaStreamRef.current = await navigator.mediaDevices.getUserMedia(mediaConstraints);
            }

            // Optional iOS fix: show 1x1 hidden video to test stream
            const testVideo = document.createElement("video");
            testVideo.srcObject = snapMediaStreamRef.current;
            testVideo.setAttribute("playsinline", "");
            testVideo.setAttribute("autoplay", "");
            testVideo.muted = true;
            testVideo.style.width = "1px";
            testVideo.style.height = "1px";
            document.body.appendChild(testVideo);

            await sessionRef.current.setSource(snapMediaStreamRef.current);
            await sessionRef.current.play();
            console.log("Snap Camera session started.");

            let currentLens;
            try {
                currentLens = await cameraKitRef.current.lensRepository.loadLens(lensId, groupId);
            } catch (e) {
                console.error("loadLens failed:", e.message || e);
                if (e.details) console.error("Details:", e.details);
                alert("Error: Please check lensId or groupId again.");
                return;
            }

            if (!currentLens) throw new Error("Lens could not be loaded!");

            await sessionRef.current.applyLens(currentLens);
            // await session.play()
            setLensLoaded(true);
            setActiveLensId(lensId);
            console.log(`Lens ${lensId} activated.`);
        } catch (error) {
            console.error("Error activating lens:", error.message || error);
            if (error.details) console.error("Details:", error.details);
        }
    }, [lensLoaded, activeLensId, apiURL, groupId]);

    useEffect(() => {
        const fetchGroupId = async () => {
            if (!barcode) return;
            const data = await getLensIdFromBarcode(barcode);
            setLensName(data.lensName ?? "Default Lens");
        };

        fetchGroupId();
    }, [barcode]);


    const handleStartClick = async () => {
        try {
            // 1. Prompt for camera permission
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // 2. Now ensure canvas is available in DOM
            ensureCanvas(); // make sure this appends <canvas id="my-canvas">

            // 3. Now initialize CameraKit AFTER user permission
            const cameraKit = await bootstrapCameraKit({
                snap: "true",
                apiToken: apiURL,
                clientId: "3157d7b6-85ec-440f-bf74-d5ead84bc956",
            });

            const canvas = document.getElementById("my-canvas");
            if (!canvas) {
                alert("Canvas not found!");
                return;
            }

            // 4. Create session & set source
            const session = await cameraKit.createSession({ liveRenderTarget: canvas });
            await session.setSource(stream);

            // 5. Preload lens
            const lens = await cameraKit.lensRepository.loadLens(lensId, groupId);
            await session.applyLens(lens);

            // 6. Start AR session
            await session.play();
            console.log("Lens activated on iPhone!");
            console.log("UA:", navigator.userAgent);
            console.log("Stream started:", !!stream);
            console.log("Canvas ready:", !!canvas);

            setReadyToActivate(true);
        } catch (err) {
            console.error("Error activating lens:", err);
            alert("Please allow camera access to continue.");
        }
    };




    const stopLens = async () => {
        try {
            navigate(-1);
        } catch (error) {
            console.error("Error closing lens:", error);
        }
    };

    return (
        <div
            style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            {!readyToActivate && (
                <button
                    onClick={handleStartClick}
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        padding: "12px 24px",
                        fontSize: "16px",
                        backgroundColor: "#000",
                        color: "#fff",
                        borderRadius: "10px",
                        zIndex: 100,
                        cursor: "pointer",
                    }}
                >
                    Start AR Lens
                </button>
            )}

            <div
                style={{
                    position: "absolute",
                    top: "50px",
                    left: "20%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "4px 8px",
                    zIndex: 10,
                    background: "rgba(0, 0, 0, 0.4)",
                    borderRadius: "6px",
                    fontSize: "13px",
                    color: "white",
                    fontWeight: "400",
                    backdropFilter: "blur(4px)",
                    whiteSpace: "nowrap",
                }}
            >
                {lensName}
            </div>

            <button
                onClick={stopLens}
                style={{
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    padding: "10px 20px",
                    fontSize: "15px",
                    background: "rgba(0, 0, 0, 0.7)",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    fontWeight: "700",
                    cursor: "pointer",
                    zIndex: 10,
                }}
            >
                Back to Scanning
            </button>

            <canvas
                ref={canvasRef}
                id="my-canvas"
                style={{
                    height: "100%",
                    width: "100%",
                    transform: "scaleX(-1)",
                    objectFit: "cover",
                }}
            />
        </div>
    );
};

export default Activatelens;
*/